import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {SellerPJDataPayload} from "../../../shared/models/sellerPj.model";
import {mapFormToDataPersonalSellerPjTwo} from "../../../utils/seller-pj-mapper.util";

@Component({
  selector: 'app-seller-step-two-pj',
  templateUrl: './seller-step-two-pj.component.html',
  styleUrls: ['./seller-step-two-pj.component.scss'],
})
export class SellerStepTwoPjComponent implements OnInit {
  @Output() formsComplete = new EventEmitter();
  @Output() dataForms = new EventEmitter<SellerPJDataPayload>();
  @Input() dataCompany = new SellerPJDataPayload();
  formStepTwo: FormGroup;

  currentRepresents: any;
  currenttProcurators: any;

  constructor() {
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.formStepTwo = new FormGroup({});
  }

  reciveCurrentRepresents($event: any) {
    this.currentRepresents = $event;
    this.checkAllFormsState();
  }

  reciveCurrentProcurator($event: any) {
    this.currenttProcurators = $event;
    if (!this.currenttProcurators.value.procurators?.length) delete this.dataCompany.attorneys;
    this.checkAllFormsState();
  }

  //no futuro revisar fluxo par evitar verificações complexas
  checkAllFormsState() {
    if (
      this.currentRepresents &&
      this.currentRepresents.formStatus === 'VALID' &&
      this.currenttProcurators &&
      this.currenttProcurators.formStatus === 'VALID'
    ) {
      this.isFormComplete();
      this.formsComplete.emit(true);
    } else {
      this.formsComplete.emit(false);
    }
  }

  isFormComplete() {
    const formValue = {
      representatives: this.currentRepresents.value.represents,
      attorneys: this.currenttProcurators.value.procurators
    };

    Object.assign(this.dataCompany, mapFormToDataPersonalSellerPjTwo(formValue));
    this.dataForms.emit(this.dataCompany);
  }
}
